import { useCallback, useState } from 'react';
import ModalAsBanner from '@/components/Modal/ModalAsBanner';
import { ELocalStorage } from '@/types/storage';
import { IModalAsSingleViewedBannerContentProps } from '@/types/modal';

interface IUseModalProps {
  ModalContent: (props: IModalAsSingleViewedBannerContentProps) => React.ReactElement;
  localStorageKey: ELocalStorage;
}

export const useModalAsSingleViewedBanner = ({ ModalContent, localStorageKey }: IUseModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(
    () => localStorage.getItem(localStorageKey) === null,
  );

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return {
    ModalToRender: () => (
      <ModalAsBanner isOpen={isModalOpen}>
        <ModalContent closeModal={closeModal} localStorageKey={localStorageKey} />
      </ModalAsBanner>
    ),
  };
};
